import { useMutation } from '@tanstack/react-query';
import { deleteBatch } from 'api';
import { toastEmitter } from 'components/Toast';

export default function useDeleteBatch({
  handleSuccess = () => null,
  handleError = () => null,
} = {}) {
  const Request = useMutation({
    mutationFn: deleteBatch,
    mutationKey: ['deleteBatch'],
    onSuccess: (data) => {
      const status = data?.status;
      const responseData = data?.data;
      if (status !== 200) {
        handleError();
        return toastEmitter('error', responseData?.error?.message);
      }
      handleSuccess();
      toastEmitter('success', responseData?.data?.message);
    },
  });
  return { ...Request };
}
